import {StoreAutoIncrement, StoreBase, StoreDataType} from "shared/core/Store/StoreBase";


export enum ConditionTypeEnum {
    ShowHide='ShowHide',
    Validation='Validation'

}

export enum ConditionLineTypeEnum {
    Standard='Standard',
    Variation='Variation',
    None='None'
    
}

export enum SubTypeEnum{
    Standard='Standard',
    MultipleValues='MultipleValues',
    Date='Date',
    Numeric='Numeric',
    Checkbox='Checkbox'
}

export enum ComparisonTypeEnum {
    Equal='Equal',
    NotEqual='NotEqual',
    IsEmpty='IsEmpty',
    IsNotEmpty='IsNotEmpty',
    None='None',
    Contains='Contains',
    NotContains='NotContains',
    GreaterThan='GreaterThan',
    GreaterOrEqualThan='GreaterOrEqualThan',
    LessThan='LessThan',
    LessOrEqualThan='LessOrEqualThan',
    IsChecked='IsChecked',
    IsNotChecked='IsNotChecked'

}

export enum ElementUsedTypeEnum{
    Field='Field',
    Variation='Variation'
}

export class ElementUsedOptions extends StoreBase{
    public Type:ElementUsedTypeEnum;
    public Id:any;

    protected LoadDefaultValues() {
        this.Type=ElementUsedTypeEnum.Field;
        this.Id='';
    }

}

export class ConditionLineOptions extends StoreBase{
    public FieldId:string;
    public Comparison:ComparisonTypeEnum;
    public Value:any;
    public Type:ConditionLineTypeEnum;
    public SubType:SubTypeEnum;


    @StoreAutoIncrement('ConditionLineOptions')
    public Id:number;
    protected LoadDefaultValues() {
        this.Id=0;
        this.FieldId='';
        this.Comparison=ComparisonTypeEnum.None;
        this.Value='';
        this.Type=ConditionLineTypeEnum.None;
        this.SubType=SubTypeEnum.Standard;
    }


    protected GetValueFromLoader(property, value: any): any {
        if(property=='Value'&&this.SubType==SubTypeEnum.MultipleValues)
        {
            if(value==''||!Array.isArray(value))
                return [];
            return value;
        }
        return value;
    }
}

export class ConditionGroupOptions extends StoreBase{
    @StoreAutoIncrement('ConditionGroupOptions')
    public Id:number;
    @StoreDataType(ConditionLineOptions)
    public ConditionLines:ConditionLineOptions[];
    protected LoadDefaultValues() {
        this.ConditionLines=[];
        this.Id=0;
    }

}


export class ConditionOptionsBase extends StoreBase{
    @StoreAutoIncrement('ConditionOptionsBase')
    public Id:number;
    public Type:ConditionTypeEnum;
    @StoreDataType(ConditionGroupOptions)
    public ConditionGroups:ConditionGroupOptions[];
    @StoreDataType(ElementUsedOptions)
    public ElementsUsed:ElementUsedOptions[];

    protected LoadDefaultValues() {
        this.Id=0;
        this.Type=ConditionTypeEnum.ShowHide;
        this.ElementsUsed=[];
        this.ConditionGroups=[];
    }
}

export class ShowHideConditionOptions extends ConditionOptionsBase{
    public ShowWhenTrue:boolean;


    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.ShowWhenTrue=true;
    }
}


export class ValidationConditionOptions extends ConditionOptionsBase{
    public IsInvalidWhenTrue:boolean;
    public InvalidMessage:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.IsInvalidWhenTrue=true;
        this.InvalidMessage='Invalid Field';
        this.Type=ConditionTypeEnum.Validation;
    }
}